import moment from 'moment';
import * as Yup from 'yup';

export const FilterSchema = Yup.object().shape({
  date: Yup.mixed().test('period', 'Selecione um período de no máximo 12 meses', (value) =>
    moment(value[1], 'DD/MM/YYYY').isSameOrBefore(moment(value[0], 'DD/MM/YYYY').add(12, 'months'))
  ),
  email: Yup.string().nullable().email('Campo não é um e-mail válido'),
});
